import styled from 'styled-components';
import { FunctionColor, Spacer, BrandColor } from '@lux/tokens';
import { Title } from '@lux/title';
import { Button } from '@lux/buttons';
import { TabList } from '@lux/tabs';

export const ContinueShoppingContainer = styled.div`
    background-color: ${FunctionColor.function0};
    padding: ${Spacer.L} ${Spacer.S};
    overflow-x: hidden;

    ul {
        gap: ${Spacer.XS};
    }
`;

export const StyledTitle = styled(Title)`
    margin-bottom: ${Spacer.SM};
`;

export const TabListWrapper = styled.div`
    /* Container wrapper without generic selectors */
`;

export const StyledTabList = styled(TabList)`
    && {
        display: flex;

        > div {
            gap: 0;
        }
    }
`;

interface StyledChipProps {
    $selected?: boolean;
}

export const Chip = styled.button<StyledChipProps>`
    /* Reset button defaults */
    all: unset;
    box-sizing: border-box;

    /* Custom styling */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    border: 1px solid ${FunctionColor.function100};
    height: ${Spacer.L};
    min-height: ${Spacer.L};
    max-height: ${Spacer.L};
    width: auto;
    min-width: auto;
    max-width: none;
    background-color: ${({ $selected }) => ($selected ? FunctionColor.function100 : 'transparent')};
    color: ${({ $selected }) => ($selected ? FunctionColor.function0 : FunctionColor.function100)};
    padding: ${Spacer.XS} ${Spacer.M};
    white-space: nowrap;
    margin: 4px;
    flex-shrink: 0;
    border-radius: 25px;

    /* Typography */
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    text-align: center;

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px ${FunctionColor.function0}, 0 0 0 4px ${BrandColor.primary};
        height: ${Spacer.L};
        min-height: ${Spacer.L};
        max-height: ${Spacer.L};
    }

    &:hover {
        background-color: ${({ $selected }) =>
            $selected ? FunctionColor.function100 : FunctionColor.function10};
        color: ${({ $selected }) =>
            $selected ? FunctionColor.function0 : FunctionColor.function100};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const SeeAllCardCarouselItem = styled(Button)`
    position: relative;
    border: 1px solid ${FunctionColor.function20};
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-align: center;
    border-radius: 0px;
    background-color: transparent;
    padding: ${Spacer.XL};

    &:hover {
        background-color: ${FunctionColor.function5};
        border: 1px solid ${FunctionColor.function20};
        transform: none;
        box-shadow: none;
    }
`;
